export const LOGIN_ROUTE = '/login'
export const CHAT_ROUTE = '/chat'


// WEBPACK FOOTER //
// ./src/utils/consts.js